import { useConversation } from '../../contexts/conversation';
import { InputType } from '../../enums/conversation';
import ButtonInput from './Button';
import FileInput from './File';
import FormInput from './Form';
import MultiselectInput from './Multiselect';
import SelectInput from './Select';

function ChatInput() {
    const { input } = useConversation();

    if (!input) return null;

    switch (input.type) {
        case InputType.BUTTON:
            return <ButtonInput />;

        case InputType.FILE:
            return <FileInput />;

        case InputType.FORM:
            return <FormInput />;

        case InputType.MULTISELECT:
            return <MultiselectInput />;

        case InputType.SELECT:
            return <SelectInput />;

        default:
            return null;
    }
}

export default ChatInput;
